import { Box } from "@mui/material";
import { gridFilteredDescendantRowCountSelector, GridRowCountProps, useGridApiContext, useGridSelector } from "@mui/x-data-grid-premium";

const CustomFooterRowCount = (props: GridRowCountProps) => {
  const { visibleRowCount: topLevelRowCount } = props;
  const apiRef = useGridApiContext();
  const descendantRowCount = useGridSelector(apiRef, gridFilteredDescendantRowCountSelector);

  // Access custom locale text using type assertion since these are custom keys
  const getLocaleText = apiRef.current.getLocaleText as (key: string) => unknown;
  const footerRowCount = getLocaleText("footerRowCount") as (count: number) => string;
  const footerGroupCount = getLocaleText("footerGroupCount") as (count: number) => string;

  // Build display text using i18next pluralization or fallback to hardcoded English
  const rowText = footerRowCount(descendantRowCount);
  const groupText = footerGroupCount(topLevelRowCount);

  return (
    <Box sx={{ mx: 2 }}>
      {rowText} {groupText}
    </Box>
  );
};

export default CustomFooterRowCount;
